import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from './reducers/modalSlice';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';

// Keep existing components
import Modal from './Components/Modal/Modal';
import CancellationPolicy from './Components/UsefulLinks/CancellationPolicy/CancellationPolicy';
import TermsAndConditions from './Components/UsefulLinks/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './Components/UsefulLinks/PrivacyPolicy/PrivacyPolicy';
import CookiePolicy from './Components/UsefulLinks/CookiePolicy/CookiePolicy';
import PageNotFound from './Components/PageNotFound/PageNotFound';

function App() {
  const showModal = useSelector((state) => state.modal.showModal);
  const activeCourse = useSelector((state) => state.modal.activeCourse);

  const dispatch = useDispatch();
  const handleCloseModal = () => dispatch(closeModal());

  return (
    <Router>
      <div>
        <Modal
          showModal={showModal}
          activeCourse={activeCourse}
          closeModal={handleCloseModal}
        />
        <Routes>
          {/* Main routes */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />

          {/* Keep policy pages */}
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/cancellationPolicy" element={<CancellationPolicy />} />
          <Route path="/CookiePolicy" element={<CookiePolicy />} />

          {/* 404 page */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
